export const initCanvas = () => {
    if (typeof window === "undefined") {
        return;
    }

    const myCanvas = document.createElement("canvas");
    myCanvas.width = window.innerWidth;
    myCanvas.height = window.innerHeight;

    myCanvas.style.position = "fixed";
    myCanvas.style.top = "0";
    myCanvas.style.left = "0";
    myCanvas.style.pointerEvents = "none";

    document.body.appendChild(myCanvas);
    return myCanvas;
};
